module.exports = __webpack_public_path__ + "img/medicine melancholy_lw.7539cbef.png";